module.exports = __webpack_public_path__ + "img/savevideo.f0f69dbd.svg";